import RoutesTabs from './RoutesTabs'

export default RoutesTabs
